// shared color map for select-option badges
export const OPTION_COLORS = {
  slate: "bg-slate-500/15 text-slate-600 dark:text-slate-300 border-slate-500/20",
  blue: "bg-blue-500/15 text-blue-600 dark:text-blue-300 border-blue-500/20",
  green: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-300 border-emerald-500/20",
  rose: "bg-rose-500/15 text-rose-600 dark:text-rose-300 border-rose-500/20",
  amber: "bg-amber-500/15 text-amber-600 dark:text-amber-300 border-amber-500/20",
  violet: "bg-violet-500/15 text-violet-600 dark:text-violet-300 border-violet-500/20",
  teal: "bg-teal-500/15 text-teal-600 dark:text-teal-300 border-teal-500/20",
};

export const COLOR_LIST = Object.keys(OPTION_COLORS);

export function OptionBadge({ value, color }) {
  if (!value) return <span className="text-muted-foreground/50">—</span>;
  const cls = OPTION_COLORS[color] || OPTION_COLORS.slate;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium border ${cls}`}
    >
      {value}
    </span>
  );
}
